import { Component, HostListener } from '@angular/core';
import { IHeaderGroupAngularComp,  } from 'ag-grid-angular';
import { ColumnGroup, IHeaderGroupParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { AttachmentService } from '../../../../../command/core/attachment/attachment.service';
import { PivotField } from '../../../../../manager/baselines/pivot-field.obj';
import { ViewData } from '../../../../../model/view.data';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';


@Component({
  selector: 'pivot-headergroup-renderer',
  templateUrl: './pivot-headergroup.renderer.html',
  styles: [':host {height:100%; width: 100%;}']

})
export class PivotHeaderGroupRenderer implements IHeaderGroupAngularComp {
  public params: IHeaderGroupParams;

  public expanded: boolean = false;

  public uniqueColumnChild: ColumnGroup = null;

  public wcio: WidgetConfigurationItemObj = null; // le contexte de cette colonne
  public pivotField: PivotField = null; // pour gestion possible de n instances d'un même pkd

  public css: any = null;
  public fontColor = null;
  public backgroundColor = null;

  public textAlign = null;

  public arrowKind(): any {
    
    if(this.params.columnGroup?.getChildren()?.length !== this.params.columnGroup?.getDisplayedChildren().length) {
      this.expanded = false;
    } else {
      this.expanded = true;  
    }

    // console.log('arrowKind', this.expanded, this.displayName);
    if (this.expanded) { // je suis ouvert, icone de fermeture
      return 'icon-reduce';
    }
    return 'icon-creation';
  }

  public binSource: Observable<string> = null;
  public isBinary: boolean = false; /** c'est un champ image */
  
  public hasChildren: boolean = false; /** inutile d'afficher le contenu si je n'ai qu'un enfant */
  // public showLabel: boolean = true; /** inutile d'afficher le contenu si je n'ai qu'un enfant */

  public get displayName(): string {
    const colDef: any = this.params.columnGroup.getOriginalColumnGroup().getColGroupDef();
    // console.log('displayName', this.params?.displayName, colDef);
    return this.params?.displayName || '';
  }
  public get subLabel(): string {
    const colDef: any = this.params.columnGroup.getOriginalColumnGroup().getColGroupDef();
    // console.log('subLabel', this.params?.displayName, colDef);
    return colDef.headSubField;
  }


  agInit(params: IHeaderGroupParams): void {
    
    this.params = params;

    const colDef: any = this.params.columnGroup.getOriginalColumnGroup().getColGroupDef();

    // this.expanded = colDef.expanded;
    // if(this.params.columnGroup.getChildren().length !== this.params.columnGroup.getDisplayedChildren().length) {
    //   this.expanded = false;
    // } else {
    //   this.expanded = true;
    // }
    if (!!colDef.binary) {
      this.binSource = AttachmentService.getInstance().downloadAttachmentForWidget(colDef.binary);
      this.isBinary = true;
    }

    if(this.params.columnGroup.getChildren()?.length === 1) {
      let childProto: any = this.params.columnGroup.getChildren()[0];
      if(childProto instanceof ColumnGroup) {
        this.uniqueColumnChild = childProto as ColumnGroup;
      }
       // = this.params.columnGroup.getChildren()[0] as any as ColumnGroup;
      
      if(!!this.uniqueColumnChild) { // c'est une sous-colonne, vide
        this.hasChildren = this.uniqueColumnChild.getChildren()?.length > 1;
      } 
      // this.hasChildren = childGp?.getChildren()?.length > 1;
    } else {
      this.hasChildren = this.params.columnGroup.getChildren().length > 1;
    }
     

    try {
      const styleParts: string[] = colDef.style?.split(ViewData.KEY_SEPARATOR);
      this.backgroundColor = styleParts[0];
      this.fontColor = styleParts[1];
    } catch (e: any) {}

    // console.log("header", params, colDef);

    switch(colDef?.textAlign) {
      case 'L':
        this.textAlign = 'left';
        break;
      case 'C':
        this.textAlign = 'center';
        break;
      case 'R':
        this.textAlign = 'right';
        break;
      default:
        this.textAlign = this.hasChildren? 'left' : 'right';
    }

    // console.log('header gp', params.displayName, this.expanded, this.params.columnGroup.isExpanded());

  }

  ngOnDestroy() {
      // console.log(`Destroying HeaderComponent`);
  }

  /** click sur l'icone expand / collapse, pour propagation */
  expandOrCollapse() {
    this.expanded = !this.expanded; // on inverse
    if(this.propagate) {
       
      if(!!this.params.columnGroup.getParent()) { // je demande l'ouverture de tous mes frères et soeurs
        let daddy: ColumnGroup =  this.params.columnGroup.getParent();
        this.params.columnApi.setColumnGroupOpened(daddy.getGroupId(), this.expanded);
        daddy.getChildren().forEach(ihc => {
          let id = (ihc as unknown as ColumnGroup)?.getGroupId();
          // console.log('tool', ihc, id);
          this.params.columnApi.setColumnGroupOpened(id, this.expanded);
        });

      } else { // niveau le plus haut
        //if(this.expanded) {
          this.params.columnApi.getAllDisplayedColumnGroups().forEach(ihc => {
            let id = (ihc as unknown as ColumnGroup)?.getGroupId();
            // console.log('tool', ihc, id);
            this.params.columnApi.setColumnGroupOpened(id, this.expanded);
          });
      }
      // console.log('propagate', this.params.columnGroup, this.expanded, this.params.columnApi.getAllDisplayedColumnGroups());

    } else {
      this.params.columnApi.setColumnGroupOpened(this.params.columnGroup.getGroupId(), this.expanded);
    }

    this.propagate = false;

  };

  public doLong(e: any): void {
    // console.log('doLong', e);
    this.propagate = true;
  }

  private _timeout: any;
  private propagate: boolean = false;
  @HostListener('mousedown') onMouseDown( e ) {
      this._timeout = setTimeout(() => {
          this.doLong( e );
      }, 500);
  }

  @HostListener('mouseup') onMouseUp() {
      clearTimeout(this._timeout);
  }

  @HostListener('mouseleave') onMouseLeave() {
      clearTimeout(this._timeout);
  }



}
